import {
  ModuleIOValueTypeEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import { FlowNodeOutputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const GetWxWorkTag: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.getWxWorkTag,
  templateType: ModuleTemplateTypeEnum.tools,
  isTool: true,
  flowType: FlowNodeTypeEnum.getWxWorkTag,
  avatar: '/imgs/module/cfr.svg',
  name: '获取企业微信标签',
  description: '获取企微上该用户的标签',
  inputs: [Input_Template_Switch],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.wxworkTags,
      type: FlowNodeOutputTypeEnum.source,
      label: '该用户的企微标签',
      valueType: ModuleIOValueTypeEnum.any,
      targets: [],
    },
  ],
};
